import { create } from "zustand";

type SortConfig = { key: string; direction: "asc" | "desc" };

interface ScriptsState {
  totalCount: number;
  totalScripts: [];
  loading?: boolean;
  sortConfig: SortConfig;
  setLoading: (loading: boolean) => void;
  setTotalCount: (total: number) => void;
  setTotalScripts: (scripts: []) => void;
  setSortConfig: (config: SortConfig | ((prev: SortConfig) => SortConfig)) => void;
}

const scriptsStore = create<ScriptsState>()((set) => ({
  totalCount: 0,
  totalScripts: [],
  loading: true,
  sortConfig: {
    key: "Date Added",
    direction: "desc",
  },
  setLoading: (loading) => set({ loading }),
  setTotalCount: (total: number) => set({ totalCount: total }),
  setTotalScripts: (scripts: []) => set({ totalScripts: scripts, loading: false }),
  setSortConfig: (config) =>
    set((state) => ({
      sortConfig: typeof config === "function" ? config(state.sortConfig) : config,
    })),
}));

export default scriptsStore;
